import { MessageSquare, History, FileText, Bot } from 'lucide-react';

interface Props {
  activeTab: string;
  onChange: (tab: string) => void;
}

export function TabsNavigation({ activeTab, onChange }: Props) {
  return (
    <div className="tabs-nav">
      <button
        className={`tab-btn ${activeTab === 'chat' ? 'active' : ''}`}
        onClick={() => onChange('chat')}
      >
        <MessageSquare size={14} />
        Asistente
      </button>
      <button
        className={`tab-btn ${activeTab === 'freechat' ? 'active' : ''}`}
        onClick={() => onChange('freechat')}
      >
        <Bot size={14} />
        Chat
      </button>
      <button
        className={`tab-btn ${activeTab === 'history' ? 'active' : ''}`}
        onClick={() => onChange('history')}
      >
        <History size={14} />
        Historial
      </button>
      <button
        className={`tab-btn ${activeTab === 'templates' ? 'active' : ''}`}
        onClick={() => onChange('templates')}
      >
        <FileText size={14} />
        Plantillas
      </button>
    </div>
  );
}
